import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import { useSessionFormState } from '@hooks/useSessionFormState';
import { useSessionAppointment } from '@hooks/useSessionAppointment';
import { useRuntimeConfig } from 'vl-common/src/hooks/Runtime';
import { SessionFormItem } from '@components/Clinicians/Session/Components/SessionFormItem';
import { type ApptActionCodes } from 'vl-common/src/schemas/getMetaAppointments';
import { useSessionAction } from '@hooks/useSessionAction';

const DetailsOfClinicFormItem = ({ actionCode }: { actionCode: ApptActionCodes }) => {
  const { t } = useTranslation('common');
  const { appointment } = useSessionAppointment();
  const { SHORT_TASK_NOTES_LIMIT: characterLimit } = useRuntimeConfig();
  const { COMMENT_KEY } = useSessionAction(actionCode);
  const [actionTaskComment, setActionTaskComment] = useSessionFormState(COMMENT_KEY);

  return (
    <SessionFormItem label={t('Details of clinic requested')} name={COMMENT_KEY} data-testid="clinic-details-input">
      <Input.TextArea
        disabled={appointment.appointment_completed || appointment.read_only}
        value={actionTaskComment}
        onChange={(e) => {
          setActionTaskComment(e.target.value || undefined);
        }}
        placeholder={t('Clinic name and postcode')}
        showCount
        maxLength={characterLimit}
        style={{ height: 60, resize: 'none' }}
      />
    </SessionFormItem>
  );
};

export default DetailsOfClinicFormItem;
